export enum NavigationEvent {
  OPEN_HAMBURGER_MENU = 'OpenHamburgerMenu',
  FOOTER_LINK_CLICK = 'FooterLinkClickEvent',
  GO_TO_WINNERS = 'GoToWinners',
  TOGGLE_THEME = 'ToggleTheme',
  SWITCH_LANGUAGE = 'SwitchLanguage',
  DOWNLOAD_APP_CLICK = 'DownloadAppClickEvent',
  GO_TO_SOCIAL_PAGE = 'GoToSocialPageClickEvent'
}
